<template>
  <div>
    <a-modal @ok="talentNoticeVisible = false" @cancel="handleCancel" :visible="talentNoticeVisible" :footer="null">
      <a-card class="card" hoverable>
        <img style="width: 100%; height: 500px" slot="cover" alt="example" :src="newJournalForm.cover" />
        <a-card-meta>
          <template slot="description">
            <h2> {{ newJournalForm.title }} </h2>
            预告时间：{{ newJournalForm.activity_start | time }} 至 {{ newJournalForm.activity_end | time }}
          </template>
        </a-card-meta>
      </a-card>
    </a-modal>
  </div>
</template>

<script>
import moment from 'moment'
import { login } from '@/api/login'
export default {
  name: '',
  components: {},
  props: {
    newJournalForm: {
      type: Object,
      default() {
        return {}
      },
    },
    ischeck: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
    }
  },
  computed: {
    talentNoticeVisible: {
      get() {
        return this.ischeck
      },
      set(v) {
        this.$emit('changeVisible', v)
      },
    },
  },
  filters: {
    time(msg) {
      return (msg = moment(msg * 1000).format('YYYY-MM-DD'))
    },
  },
  methods: {
    handleCancel() {
      this.talentNoticeVisible = false
    },
  },
}
</script>

<style scoped lang="less">
.card {
  width: 95%;
  margin: 0 auto;
  text-align: center;
  font-size: 16px;
  h2 {
    text-align: center;
  }
}
</style>
